import { MutableRefObject, useRef } from 'react';

type DownloadedFileInfo = {
  readonly downloadFile: (filename: string, data: any, mimeType?: string) => Promise<void>;
  readonly downloadFileRef: MutableRefObject<HTMLAnchorElement | null>;
}

export const useDownloadFile = (): DownloadedFileInfo => {
  const downloadFileRef = useRef<HTMLAnchorElement | null>(null);

  const downloadFile = async (filename: string, data: any, mimeType: string = 'application/pdf') => {
    const base64String = `data:${mimeType};base64,${data}`;
    if (downloadFileRef?.current) {
      downloadFileRef.current.download = filename;
      downloadFileRef.current.href = base64String;
      downloadFileRef.current?.click();
    }
  };

  return {
    downloadFile, downloadFileRef,
  };
};
